import React from 'react';
import './Form.min.css';
import Menu from '../menu/Menu'
const Form = props => {


    return (
     
        <form onSubmit={props.submit} id='form' >
            <input type="text" 
            id='input'
            placeholder='Wpisz nazwę miasta'
            value = {props.value}
            onChange = {props.change}
            ></input>
            <button >Wyszukaj miasto</button>
                 
         <Menu {...props}/>
         <p id='one'></p>
         <p id='two'></p>
         <p id='three'></p>
         <p id='four'></p>
         <p id='five'></p>
         <p id='six'></p>
         <p id='seven'></p>
         <p id='sun'></p>
         <p id='stop'></p>
        </form>
        
    )
}

export default Form;